import axios from 'axios';

export type DraftData = {
  expirationDate: Date | string;
  infoText: string;
  files: any[];
  priceTypeUnits: any[];
  demands: any[];
  priceTypes: any[];
  senderMsg: string;
  fileScopeQuotationId: string;
  fileScopeQuotationVersion: number;
  supplierContacts: any[];
  fileAreaRoot: string | null;
};

export type BidRequestDraft = {
  _id: string;
  orgId: string;
  projectId: string;
  areaId: string;
  quotationVersion: number;
  savedBy: { _id: string; name: string } | null;
  data: DraftData;
  createdAt: string;
  updatedAt: string;
};

export type SaveConflict = {
  error: 'conflict';
  savedBy: string;
  savedAt: string;
};

class ServiceBidRequestDraftClass {
  async getDraft(
    projectId: string,
    areaId: string
  ): Promise<BidRequestDraft | null> {
    const response = await axios.get<BidRequestDraft | null>(
      `/api/bid-request-draft/${projectId}/${areaId}`
    );
    return response.data;
  }

  async saveDraft(
    projectId: string,
    areaId: string,
    quotationVersion: number,
    data: DraftData,
    lastKnownUpdatedAt: string | null
  ): Promise<BidRequestDraft | SaveConflict> {
    try {
      const response = await axios.put<BidRequestDraft>(
        `/api/bid-request-draft/${projectId}/${areaId}`,
        { data, quotationVersion, lastKnownUpdatedAt }
      );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 409) {
        return error.response.data as SaveConflict;
      }
      throw error;
    }
  }

  async deleteDraft(projectId: string, areaId: string): Promise<void> {
    await axios.delete(`/api/bid-request-draft/${projectId}/${areaId}`);
  }
}

const ServiceBidRequestDraft = new ServiceBidRequestDraftClass();
export default ServiceBidRequestDraft;
